import React, { useState } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Popover,
} from '@mui/material';

import { MoreActionIconButtonProps } from './props';

export const MoreActionIconButton: React.FC<MoreActionIconButtonProps> = (
  props
) => {
  const { moreActionIcon, items = [] } = props;

  // ======================= STATE
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  // ======================= EVENTS
  const onHandleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const onHandleClose = () => {
    setAnchorEl(null);
  };

  // ======================= VARIABLES
  const open = Boolean(anchorEl);
  const id = open ? 'action-popover' : undefined;

  // ======================= VIEWS
  return (
    <>
      <IconButton onClick={onHandleClick}>
        {moreActionIcon ?? <MoreVertIcon />}
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={onHandleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{
          '& .MuiPopover-paper': {
            padding: '0px',
          },
        }}
      >
        <List>
          {items.map((e: any) => {
            return (
              <div key={e.value}>
                <ListItemButton
                  key={e.value}
                  onClick={(
                    event:
                      | React.MouseEvent<HTMLAnchorElement>
                      | React.MouseEvent<HTMLDivElement>
                  ) => {
                    event.stopPropagation();
                    onHandleClose();
                    e.onSelect();
                  }}
                >
                  <ListItemText
                    primary={e.label}
                    primaryTypographyProps={{
                      sx: { fontSize: 14 },
                      color: e.color ?? 'primary',
                    }}
                  />
                </ListItemButton>
              </div>
            );
          })}
        </List>
      </Popover>
    </>
  );
};

// ======================= EXPORT
export * from './props';
export default MoreActionIconButton;
